import styles from './styles/Activity.module.scss';
import { UserDTO } from '@behavior/init/dto/UserDTO';
import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import { AdvancedDatePickerWrapper } from 'react-lib/dist/components-es';
import CurrentRemoveDateButtonsWrapper from '@components/common/CurrentRemoveDateButtonsWrapper';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CommonTagsInputWrapper from '@components/common/CommonTagsInputWrapper';
import { personsActions } from '@behavior/persons';
import CurrentRemoveUserTagButtonsWrapper from '@components/common/CurrentRemoveUserTagButtonsWrapper';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';
import lodash from 'lodash';

type Props = {
  setDefaultUser: (val: boolean) => void;
  updateUserDateFieldsValidation: (val?: any) => void;
  updateDataField: (val: any) => void;
  setFieldVal: (val: string, date: any) => void;
  userVal?: UserDTO | PersonDTO;
  userValueWithoutPersonalData?: UserDTO | PersonDTO;
  setUserValueWithoutPersonalData?: (userValueWithoutPersonalData: any) => void;
  dteVal?: any;
  userLabel?: string;
  dateLabel?: string;
  placeholder?: string;
  nameUser: string;
  dteName: string;
  disabled?: boolean;
  showPersonalData?: boolean;
  isDateRequired?: boolean;
  showDateField?: boolean;
  isUserValRequired: boolean;
};

const UserDateInput = ({
  setDefaultUser,
  updateUserDateFieldsValidation,
  updateDataField,
  setFieldVal,
  userVal,
  userValueWithoutPersonalData,
  setUserValueWithoutPersonalData,
  dteVal,
  userLabel,
  dateLabel,
  placeholder,
  nameUser,
  dteName,
  disabled,
  showPersonalData,
  isDateRequired,
  showDateField,
  isUserValRequired,
}: Props) => {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const {
    register,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();
  const { t } = useTranslation();

  useEffect(() => {
    if (!showPersonalData && userValueWithoutPersonalData && setUserValueWithoutPersonalData) {
      const modifiedUserValueWithoutPersonalData = cloneDeep(userValueWithoutPersonalData);
      modifiedUserValueWithoutPersonalData.name =
        modifiedUserValueWithoutPersonalData.name?.replace(/[a-z]/g, 'x');

      setUserValueWithoutPersonalData(modifiedUserValueWithoutPersonalData);
    }
  }, [showPersonalData]);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
      if (!userVal) {
        return;
      }
    }
    setValue(nameUser, userVal);
    trigger([nameUser]);
  }, [userVal]);

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
      if (!dteVal) {
        return;
      }
    }
    setValue(dteName, dteVal);
    trigger([dteName]);
  }, [dteVal]);

  const renderAdvancedDatePicker = (props: any) => (
    <div className="dateCompletionInputContainer">
      <div className={styles.errorMessage}>{lodash.get(errors, dteName)?.message?.toString()}</div>
      <AdvancedDatePickerWrapper
        noBorder
        value={typeof dteVal === 'string' ? moment(dteVal) : dteVal}
        openDirection={'down'}
        disabled={disabled}
        setFieldValue={setFieldVal}
        renderDefaultButtons={
          <CurrentRemoveDateButtonsWrapper
            {...props}
            buttonClassName={'currentRemoveDateButtons'}
            dteName={'dteVal'}
            setFieldValue={setFieldVal}
          />
        }
      />
    </div>
  );

  return (
    <div className={styles.resolverContainer}>
      <div className={styles.resolverDiv}>
        {userLabel && userLabel.length != 0 && <div>{t(userLabel || '')} *</div>}
        <div className={styles.errorMessage}>
          {lodash.get(errors, nameUser)?.message?.toString()}
        </div>
        <GridColumnInputWrapper
          {...register(nameUser, {
            required: isUserValRequired ? t('activity.form.error.field.required') : '',
          })}
          name={nameUser}
          disabled={disabled}
          specialRequiredCondition={isUserValRequired}
          render={(props: any) => (
            <CommonTagsInputWrapper
              {...props}
              placeholder={placeholder}
              matchProperty="name"
              displayProps="name"
              value={showPersonalData ? userVal : userValueWithoutPersonalData}
              maxTags={1}
              onlyUnique
              onSelect={updateUserDateFieldsValidation}
              className="inputWithTwoInputDefaultButtons"
              dynamicSuggestionListAction={personsActions.getPersonAutocompleteListAction}
              renderDefaultButtons={
                <CurrentRemoveUserTagButtonsWrapper setDefaultUser={setDefaultUser} {...props} />
              }
            />
          )}
        />
      </div>
      {showDateField && (
        <GridColumnInputWrapper
          {...register(dteName, {
            required: isDateRequired ? t('activity.form.error.field.required') : '',
          })}
          name={dteName}
          label={dateLabel}
          disabled={disabled}
          specialRequiredCondition={isDateRequired}
          onChange={updateDataField}
          className={'inputWithTwoInputDefaultButtons'}
          render={renderAdvancedDatePicker}
        />
      )}
    </div>
  );
};

UserDateInput.defaultProps = {
  isDateRequired: true,
  showDateField: true,
  isUserValRequired: true,
};

const mapStateToProps = (state: any) => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
});

export default connect(mapStateToProps, null)(UserDateInput);
